export const createSupportMeasuresFormRepository = (appFetch) => {
    return {
        send(body, options = {}) {
            return appFetch.post(options.url || '/cabinet/support-measures/api/send', body, options);
        },
    };
};
